export enum EntityType {
    Unknown = 0,
    PrescriptionHardCopyAnnotation = 1,
    Patient = 2,
    Case = 3,
    Program = 4,
    PriorAuthorization = 5,
    DispenseError = 6,
    RxTransferQueue = 7,
    Prescriber = 8,
    PrescriberFollowUpCase = 9,
    ElectronicPriorAuthorization = 10,
    DrugShortageReport = 11,
    SurplusReports = 12,
    GsddDrug = 13,
    NonGsddDrug = 14,
    CompoundDrug = 15,
    Plan = 16,
    PriceSchedule = 17,
    UserTask = 18,
    Order = 19,
    Consultation = 20,
    Image = 21,
    Claim = 22,
    PAP = 23,
    DrugCategory = 24,
    IngestionQueueItem = 25,
    OnlineOrder = 26,
    Prescription = 27,
    Store = 28,
    Vendor = 29,
    CallLog = 30,
    Fax = 31,
    SMSLog = 32,
    PatientWebAllergyUpdate = 33,
    PatientAppDeliverySurvey = 34,
    MedSyncEnrollment = 35
}
